import type { CoreConfig } from "@/core"
import type { EmailConfig } from "@/email"

import { resolveWebsiteUrl } from "./website-url"

export type Config = CoreConfig & EmailConfig

const config: Config = {
  core: {
    supportEmail: "hello@kestly.com.au",
    websiteUrl: resolveWebsiteUrl(import.meta.env.VITE_WEBSITE_URL, import.meta.env.PROD),
    projectName: "Kestly",
    darkMode: true,
    tagline: "Mileage, receipts and invoices for Australian sole traders",
    appTitle: "Kestly - Mileage, receipts and invoices",
  },
  email: {
    from: "Kestly <onboarding@resend.dev>",
  },
}

export default config
